import React, { useEffect, useRef, useState } from "react";
import "./Contador.css";

function Contador({ target, label }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            let start = 0;
            const increment = Math.ceil(target / 100); // velocidade proporcional

            const updateCount = () => {
              start += increment;
              if (start <= target) {
                setCount(start);
                requestAnimationFrame(updateCount);
              } else {
                setCount(target);
              }
            };

            updateCount();
            observer.unobserve(ref.current); // evita repetir
          }
        });
      },
      { threshold: 0.5 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [target]);

  return (
    <div className="col-12 col-md-4 text-center">
      <h3 ref={ref} className="contador-numero">+{count}</h3>
      <p className="descricao-contador scroll-reveal-zoom">{label}</p>
    </div>
  );
}

export default function SecaoContador() {
  return (
    <section className="contador-wrapper py-5">
      <div className="container">
        <div className="row">
          <Contador target={30} label="Serviços Oferecidos" />
          <Contador target={15} label="Clientes" />
          <Contador target={200} label="Serviços Entregues" />
        </div>
      </div>
    </section>
  );
}
